// 简单的语言包加载函数
//import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';
//import en from './en.json';

// 语言资源配置
const resources = {
  //'zh-Hans': zhHans,
  'zh-Hant': zhHant,
  //'en': en,
};

// 默认语言
let currentLanguage = 'zh-Hant';

// 切换语言
export const changeLanguage = (lang) => {
  if (resources[lang]) {
    currentLanguage = lang;
  } else {
    console.warn(`Language ${lang} not found, falling back to default.`);
  }
};

// 获取翻译
export const t = (key) => {
  return resources[currentLanguage][key] || key;
};
